import React from 'react'

export const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-16 h-16',
    large: 'w-24 h-24'
  }

  return (
    <div className="min-h-screen flex justify-center items-center bg-gradient-to-br from-gray-50 via-white to-gray-100">
      <div className="text-center">
        <div className={`${sizeClasses[size]} border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4`}></div>
        <p className="text-lg text-gray-600 font-medium">{text}</p>
      </div>
    </div>
  )
}
